import AbstractHandler from '@/language/handlers/AbstractHandler';
import Language from '@/language/Language';
import I18n from '@/i18n/I18n';
import Handler from '@/language/handlers/Handler';
import VueI18n from 'vue-i18n';

export default class I18nHandler extends AbstractHandler {
    private i18n: VueI18n;

    constructor(nextHandler?: Handler) {
        super(nextHandler);

        this.i18n = I18n;
    }

    handle(language: Language): void {
        if (this.i18n.locale !== language.code) {
            this.i18n.locale = language.code;
        }

        super.handle(language);
    }
}
